
import { Component, Vue, Watch } from "vue-property-decorator";

import FormBase from "@/lib/view-base/formbase";
import {UpdateProductCategoryDto, ProductCategoryService } from "@/api/service-proxies";
import SelectTree from "@/components/SelectTree/SelectTree.vue";
import WangEditor from 'wangeditor'
import appconst from "@/lib/appconst";
@Component({
    name: "UpdateProduc",
    components: {
        SelectTree,
    },
})
export default class CreateTenant extends FormBase {
    productcategory: UpdateProductCategoryDto = new UpdateProductCategoryDto();
    productCategoryService: ProductCategoryService = new ProductCategoryService();
    rules: object = {
        name: [{ required: true, message: "请输入标题名称", trigger: "blur" }],
        subtitle: [
            { required: true, message: "请输入副标题描述", trigger: "blur" },
        ]
       
    };
    options= [{
          value: '1',
          label: '单位(件)'
        }, {
          value: '2',
          label: '单位(人)'
        }]
    
    imageUploadAction = appconst.remoteServiceBaseUrl + 'sysadmin/UploadFile/ProductUpload'
    inputValue2: any = '' // 正文内容  textarea框值
    productImg = ''
    mounted() {
      
        this.getProduct(+this.$route.params["id"]);
     
    }


    async getProduct(id: number) {
    let productcategory = await this.productCategoryService.get(id);
    console.info("返回类型"+productcategory);
    this.productcategory = <UpdateProductCategoryDto>productcategory;
  }


    created() { }


    async submitExecute(): Promise<void> {
    
        await this.productCategoryService.update(this.productcategory);
    }


    
}
